
$( document ).ready(function() {
  
  $(".imgLiquidFill").imgLiquid();

  $('a[data-wallpaper]').lightcase();
  
  if (!/MSIE|IEMobile|Firefox|iPhone|iPad|iPod|Android|webOS|BlackBerry|IEMobile|Opera Mini|Trident/i.test(window.navigator.userAgent)) {
    $('.scrollbarY').mCustomScrollbar({
      axis: "y",
    });
  }
  
  // $('img.first').bicubicImgInterpolation({
  //     crossOrigin: 'anonymous'
  // });

  /* ==========================================================================
        * nav
  ==========================================================================*/
  function clickMode (){

    $(".language").click(function(e) {    
      e.stopPropagation();
  
      var main = document.querySelector("main");
      var panel = document.querySelector(".panel");
      
      function close(){
        $(".language").children("ul").stop().css("display", "none");
      }
  
      function windowEvent (){
        close();
        main.removeEventListener("click",windowEvent);
        panel.removeEventListener("click",windowEvent);
        // console.log("windowEvent");
      }
  
      if ( $(this).children("ul").is(":visible") ) {
        close();
        main.removeEventListener("click",windowEvent);
        panel.removeEventListener("click",windowEvent);
      } else {
        $(".language").children("ul").fadeIn().css("display", "flex");
        main.addEventListener('click', windowEvent, false);
        panel.addEventListener('click', windowEvent, false);
      }
       
    });
  }

  if (  $( window ).width() < 769 ) {                           //language語系

    clickMode();
  } else {
    $(".language").hover(function() {    
      $(this).children("ul").fadeIn().css("display", "flex");
    },function () {
      $(this).children("ul").stop().css("display", "none");
    });
  }

  $(".menu").on('click', function() {
    $(this).toggleClass("expend");
    if ( $(".search").hasClass("expend") ) {
      $(".search").removeClass("expend");
    }
    $("#nav .primary + ul").stop(true).slideUp(300);
  });

  $(".menu .panel").on("click", function(e) {
    e.stopPropagation();
  });

  if (  $( window ).width() < 769 ) {
    $("#nav .primary .arrow ").on('click', function(e) {
      e.preventDefault();
      $("#nav .primary + ul").stop(true).slideUp(300);
      $(this).parent(".primary").next("ul").stop(true).slideToggle(300);
  
      $(this).parent(".primary").toggleClass("expend");
      $(this).parent(".primary").parent("li").siblings("li").children(".primary").removeClass("expend");
    });

  } else {
    
    $("#nav .primary .arrow ").on('click', function(e) {
      e.preventDefault();
    });

    var timer;
    $("#nav .primary .arrow").hover(function(e) {
        var $this = $(this);
                
        timer = setTimeout(function() {
          $("#nav .primary + ul").stop(true).slideUp(300);
          $this.parent(".primary").next("ul").stop(true).slideDown(300);
          $this.parent(".primary").addClass("expend");
          
        }, 200);
      }, function() {
        clearTimeout(timer);
        $(this).parent(".primary").parent("li").siblings("li").children(".primary").removeClass("expend");
      });
  }

  $("#nav .primary .all-dropdwon ").on('click', function(e) {  //Application 特殊情況
    e.preventDefault();
    $(this).next(".arrow").trigger("click");
  });

  $(".search").on('click', function() {
    $(this).toggleClass("expend");

    if ( $(".menu").hasClass("expend") ) {
      $(".menu").removeClass("expend");
    }
  });

  $(".search .panel").on("click", function(e) {
    e.stopPropagation();
  });


  if (  $( window ).width() < 769 ) {
    $("#footer .logo a[data-wallpaper]").replaceWith("<a href='http://weixin.qq.com/r/hypSSl-EFAJrrRsp93_V' , target='_blank'><span class='icon-linkedin'></span></a>");
    // $("#footer .logo a[data-wallpaper]").replaceWith("<a href='weixin://scanqrcode/r/hypSSl-EFAJrrRsp93_V' , target='_blank'><span class='icon-linkedin'></span></a>");
    
  }
  
/* ==========================================================================
            * nav End
  ==========================================================================*/

  /* ==========================================================================
            * 頁面區塊
  ==========================================================================*/

  /*== 01-index.html =========================== */

  if( $( window ).width() <= 400 ){

    if( $(" #index .slider").hasClass("onlyText") ){
      $("#index .sub + ul").show();

    } else {
      $("#index .bgc1").css("backgroundImage", "url(./styles/images/01-landing02.jpg)");
      // $("#index .bgc1 .group img.replace").attr("src", "./styles/images/01-all-03-360.jpg");
    }
  }
  /*== 03-about.html =========================== */

  $("#support .context .question").click(function(){
    $(this).next(".answer").slideToggle(200);
    $(this).toggleClass("active");
  });
  $window.on("load", function() {
    $("#support .context li:nth-child(3) .question").trigger("click");
  });

  /*== 09-RMA.html =========================== */


  $("#RMA .container .btn").click(function () {

    $(this).hide();
    
    $("#RMA .login").slideDown().css("display","flex");

  });

  $('#video a[data-rel^=lightcase]').lightcase();

  $('#inquiry a[data-rel^=lightcase]').lightcase();

  /*== 31- inquiry.html =========================== */


  var lists = JSON.parse(localStorage.getItem("lists")) || [];
  console.log(lists.length);
  
  function checkTypelist(){
    if ( lists.length == 0 ) {
      $("#inquiry .typelist").hide();
    }  
  }
  checkTypelist();
  

  function addList() {                        //將勾選的型號記錄到locaol storage
    $("#infobox .btn").on("click", function () {
      lists = [];

      $("#infobox input:checkbox").each(function () {
        if ($(this).is(":checked")) {
          var value = $(this)[0].value;
          lists.push(value);
        }
      });
      localStorage.setItem("lists", JSON.stringify(lists));
    });
  }

  // $('#detail a[data-rel^=lightcase]').lightcase({    //開啟infobox時
  $('a[href="#infobox"]').lightcase({    //開啟infobox時
    onBeforeShow : {
      quux: function() {
        $("a[href='#confirm']").lightcase();  //初始化下一個lightcase
        addList();                            //綁定按鈕事件，因為按鈕原先為display none
      }
    },
  });
  
  function renewlocalStorage() {
    $("#inquiry .row .mark").each(function(){
      lists.push($(this).attr("data-type"));
    });
  }

  if($('main').children().is('#inquiry')){    
    lists = JSON.parse(localStorage.getItem("lists"));  //讀取已勾選的型號
    lists.forEach(function (i) {
      $("#inquiry [data-type="+i+"]").addClass("mark"); //標記圖案
    });

    $("#inquiry .block").click(function () {  
      $(this).removeClass("mark");

      lists = [];
      renewlocalStorage();                              //每次點擊，更新locaol storage紀錄
      localStorage.setItem("lists", JSON.stringify(lists));
      console.log(lists);
      checkTypelist();  
    });
  }

  /*==  27 location =========================== */

  // // 右側地圖欄位

  var map = $('#map');
  var position = ( $( window ).width() < 1300 )? ['25.038619', '121.542869'] : ['40.084284', '18.767345'] ;
  var customized = [
    {
        "featureType": "all",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "saturation": 36
            },
            {
                "color": "#333333"
            },
            {
                "lightness": 40
            }
        ]
    },
    {
        "featureType": "all",
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "color": "#ffffff"
            },
            {
                "lightness": 16
            }
        ]
    },
    {
        "featureType": "all",
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "administrative",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#fefefe"
            },
            {
                "lightness": 20
            }
        ]
    },
    {
        "featureType": "administrative",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#fefefe"
            },
            {
                "lightness": 17
            },
            {
                "weight": 1.2
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#f5f5f5"
            },
            {
                "lightness": 20
            }
        ]
    },
    {
        "featureType": "landscape.natural.landcover",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#ff0000"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#f5f5f5"
            },
            {
                "lightness": 21
            }
        ]
    },
    {
        "featureType": "poi.park",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#dedede"
            },
            {
                "lightness": 21
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#ffffff"
            },
            {
                "lightness": 17
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#ffffff"
            },
            {
                "lightness": 29
            },
            {
                "weight": 0.2
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#ffffff"
            },
            {
                "lightness": 18
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#ffffff"
            },
            {
                "lightness": 16
            }
        ]
    },
    {
        "featureType": "transit",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#f2f2f2"
            },
            {
                "lightness": 19
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#e9e9e9"
            },
            {
                "lightness": 17
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#dcdcdc"
            }
        ]
    }
];
  var makers = [
    {
      'event': function () {
        myClick(this, '<div class="info"> C1-805，1599 xinjinqiao road, pudong new area, Shanghai.</div>'); 
      },
      'addr': ['31.257079', '121.619915'],
      // 'text': `<div class="info"> C1-805，1599 xinjinqiao road, pudong new area, Shanghai.</div>`,
      'icon': {
        'url': './styles/images/27-dot.png',
      },

    },{
      'event': function () {
        myClick(this, '<div class="info">222, Block A, Jinmao Building, No.18 Xizhimen Street, Xicheng District, Beijing ，China  </div>'); 
      },
      'addr': ['39.939002', '116.348995'],
      // 'text': `<div class="info">222, Block A, Jinmao Building, No.18 Xizhimen Street, Xicheng District, Beijing ，China  </div>`,
      'icon': {
        'url': './styles/images/27-dot.png',
      }
    },{
      'event': function () {
        myClick(this, '<div class="info"> 917, Building A3, Xingsha Jinke Times Center, Changsha , China  </div>'); 
      },
      'addr': ['28.241989', '113.083802'],
      // 'text': `<div class="info"> 917, Building A3, Xingsha Jinke Times Center, Changsha , China  </div>`,
      'icon': {
        'url': './styles/images/27-dot.png',
      }
    },{
      'event': function () {
        myClick(this, '<div class="info"> 509, Building B, Art Culture Industrial Park, ShaYuan Po 1970, Minzhi Street, Longhua New District, Shenzhen 518110, China   </div>'); 
      },
      'addr': ['22.540787', '114.055926'],
      // 'text': `<div class="info"> 509, Building B, Art Culture Industrial Park, ShaYuan Po 1970, Minzhi Street, Longhua New District, Shenzhen 518110, China   </div>`,
      'icon': {
        'url': './styles/images/27-dot.png',
      }
    },{
      'event': function () {
        myClick(this, '<div class="info"> No.30, South Xinglin Rd., Jimei District, Xiamen, Fujian 361022, China  </div>'); 
      },
      'addr': ['24.556304', '118.039853'],
      // 'text': `<div class="info"> No.30, South Xinglin Rd., Jimei District, Xiamen, Fujian 361022, China  </div>`,
      'icon': {
        'url': './styles/images/27-dot.png',
      }
    },{
      'event': function () {
        myClick(this, '<div class="info"> 9F., No.141, Sec.3, Renai Rd., Danan., Taipei City 106, Taiwan(R.O.C)  </div>'); 
      },
      'addr': ['25.038619', '121.542869'],
      // 'text': `<div class="info"> 9F., No.141, Sec.3, Renai Rd., Danan., Taipei City 106, Taiwan(R.O.C)  </div>`,
      'icon': {
        'url': './styles/images/27-dot.png',
      }

    },{
      'event': function () {
        myClick(this, '<div class="info"> 5F, Daini Ueno Bldg., 3-7-18 Shin-Yokohama, Yokohama 222-0033 Japan  </div>'); 
      },
      'addr': ['35.509956', '139.617171'],
      // 'text': `<div class="info"> 5F, Daini Ueno Bldg., 3-7-18 Shin-Yokohama, Yokohama 222-0033 Japan  </div>`,
      'icon': {
        'url': './styles/images/27-dot.png',
      }
    },{
      'event': function () {
        myClick(this, '<div class="info"> 215 Central Ave., Holland, MI 49423  </div>'); 
      },
      'addr': ['42.818627', '-85.964608'],
      // 'text': `<div class="info"> 215 Central Ave., Holland, MI 49423  </div>`,
      'icon': {
        'url': './styles/images/27-dot.png',
      }
    },{
      'event': function () {
        myClick(this, '<div class="info"> "Silicon Valley site 1137 Cadillac Court Milpitas, CA  95035"  </div>'); 
      },
      'addr': ['37.444651', '-121.918276'],
      // 'text': `<div class="info"> "Silicon Valley site 1137 Cadillac Court Milpitas, CA  95035"  </div>`,
      'icon': {
        'url': './styles/images/27-dot.png',
      }
    },
    
    {
      'event': function () {
        myClick(this, '<div class="info"> Logistik Technologie Im Funkwerk 3 99625 Kölleda Germany  </div>'); 
      },
      'addr': ['51.196108', '11.205013'],
      // 'text': `<div class="info"> Logistik Technologie Im Funkwerk 3 99625 Kölleda Germany  </div>`,
      'icon': {
        'url': './styles/images/27-dot.png',
      }
    },
  ]
  function myClick (marker, content) {    
    
    map.tinyMap('get', 'marker', function (ms) {        
      ms.forEach(function (m) {
          m.infoWindow.close();
          m.setOptions({
            'icon': './styles/images/27-dot.png'
        });
      });
    });

    marker.infoWindow.setOptions({        //不知為何一定要?否則會無效
      'content': content,
      maxWidth: 300,

    });

    marker.infoWindow.open(marker.map, marker);
    marker.setOptions({
      'icon': './styles/images/27-maker-sm.png'
    });
                
    google.maps.event.addListener(marker.infoWindow, 'closeclick', function () {
      marker.setOptions({
        'icon': './styles/images/27-dot.png'
      });
    });
  }

  map.tinyMap({
    'center': position,
    'zoom': 3,
    styles: customized,
    'marker': makers,
  });

  $('#location [data-addr]').each(function(){
    $(this).on('click', function(){
      var mapAddr = $(this).attr("data-addr");
      $('#map').tinyMap('panTo', mapAddr);
      $('#map').tinyMap('modify', {
        zoom: 6,
      });
    });
  });
  
  if ($('.submenu.slick').hasClass("slick-initialized")) {
    
    $(window).on('resize', function() {
      $('.submenu.slick').slick('resize');
    });
  }



  

  //因應第一欄td為絕對定位，會形成表格高度不一致問題，因而用JS讀取最高值、設定。
  var $tableRow = $("table tr");
  $tableRow.each(function () {

    var $td = $(this).find("td");
    var heightArray = [];

    $td.each(function () {
      heightArray.push(this.clientHeight);
    });
    
    $td.each(function () {
      this.style.height = Math.max(...heightArray)+"px";
    });  
  });
 

}); // document ready End


/* ==========================================================================
          *animation scroll trigger
==========================================================================*/


var $animation_elements = $(".animate");

var $window = $(window);

function check_if_in_view() {
  var window_height = $window.height();
  var window_top_position = $window.scrollTop();
  var window_bottom_position = window_top_position + window_height;


  function addView() {
    var $element = $(this);
    var element_height = $element.outerHeight();
    var element_top_position = $element.offset().top;
    var element_bottom_position = element_top_position + element_height;

    if (
      element_bottom_position >= window_top_position &&
      element_top_position <= (window_bottom_position)
      // element_top_position <= (window_bottom_position - (window_height / 6))  //讓主體物件在viewport中央位置，再起始動畫
    ) {
      $element.addClass("in-view");
    }
    if ($element.hasClass("bottom")) {
      if (element_top_position <= (window_bottom_position)) { $element.addClass("in-view"); }
    }
  }

  $.each($animation_elements, addView);
  $("main").each(addView);
}

$window.on("load", function() {
  $window.on("scroll resize", check_if_in_view);
  $window.trigger("scroll");
});

/* ==========================================================================
          * slick
==========================================================================*/


if( $( window ).width() < 1301 ){
  
  $('.submenu.slick').slick({
    arrows: true,
    dots: false,
    infinite: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: false,
    // adaptiveHeight: true,
    // variableWidth: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 4,
        },
      },{
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2,
        },
      },
    ]
  });
}
  
$(".slider").slick({
  arrows: true,
  dots: true,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  speed: 1200,
  fade: true,
  responsive: [
    {
      breakpoint: 540,
      settings: {
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false
      }
    }
  ]
});

$(".slider-application").slick({
  arrows: false,
  dots: true,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  speed: 1200,
  fade: true,
});

$(".slicker-4").slick({
  arrows: true,
  dots: false,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: false,
  speed: 1200,
  rows: 2,
  slidesPerRow: 4,

  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesPerRow: 3,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesPerRow: 2,
      }
    },
    {
      breakpoint: 400,
      settings: {
        slidesPerRow: 1,
      }
    }
  ]
});

$(".slicker-3").slick({
  arrows: true,
  dots: false,
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 3,
  autoplay: false,
  speed: 1200,

  responsive: [
    {
      breakpoint: 781,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      }
    },
    {
      breakpoint: 481,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      }
    }
  ]
});



$( document ).ready(function() {

  var elem = document.querySelectorAll("#location .slicker-3 .block");
  var heightArray = [];
  
  for(var i = 0; i < elem.length; i++){
    heightArray.push(elem[i].clientHeight);
  }
  //   for(i = 0; i < elem.length; i++){
  //     elem[i].style.height = Math.min(...heightArray)+"px";
  //   }
  $("#location .slicker-3 .block").css("height", Math.max(...heightArray));
});


/*==  19 detail =========================== */

var tiSlick = $('.slider-for').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 4500,

  fade: true,
  asNavFor: '.slider-nav',
  responsive: [
    {
      breakpoint: 991,
      settings: {
        autoplay: false,
      }
    }
  ]
});

if (document.querySelector(".slider-nav") !== null) {
  var sliderNum = $(".slider-nav").find('img').length;
  // var sliderNum = document.querySelector(".slider-nav").childNodes.length;
  console.log("sliderNum is " + sliderNum);
}

$(".slider-nav").slick({
  slidesToShow: 5,
  slidesToScroll: 1,
  // asNavFor: ".slider-for",
  dots: false,
  arrows: false,
  focusOnSelect: true,

  // rows: 2,
  // slidesPerRow: 2,

  

});

$( document ).ready(function() {

  var nav = $('.slider-nav .slick-slide');

  // nav.removeClass('slick-active');
  // nav.eq(0).addClass('slick-active');
  // $('.slider-for').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
  //   var mySlideNumber = nextSlide;
  //   nav.removeClass('slick-active');
  //   nav.eq(mySlideNumber).addClass('slick-active');
  // });
  
  // $('.slider-wrap .nav-wrap .slick-prev').on('click', function(){
  //   $(".slider-for").slick('slickPrev');
  // });
  // $('.slider-wrap .nav-wrap .slick-next').on('click', function(){
  //   $(".slider-for").slick('slickNext');
  // });

  // setTimeout(function () {
  //   $('.slider-for').slick('slickGoTo', 1);
  // },1000);
  // $(window).resize(function () {
  //   var current = $(".slider-nav").slickCurrentSlide();
  //   $(".slider-nav").slickGoTo(current);
  // });

});

// $(window).resize(function () {
//   var current = $('.my-slider').slickCurrentSlide();
//   $('.my-slider').slickGoTo(current);
// });

// var $slider = $(".slider-nav"); // my slider


// $(window).resize(function () {
//   clearTimeout(timeout);
//   var timeout = setTimeout(function () {
//     $slider.slick('slickGoTo', 0);
//   }, 100);
// });
